/* ============ MEOWS HOMEPAGE — interactions ============ */
const NAVY = '#15264F', BLUE = '#2C66E0', TAN = '#E0A94E', TAN_L = '#F0D9A8', GREY = '#C9CDD6';
function svgWrap(inner){ return `<svg viewBox="0 0 120 120">${inner}</svg>`; }
const illuJoint = svgWrap(`
  <rect x="48" y="6" width="24" height="44" rx="11" fill="${GREY}" stroke="${NAVY}" stroke-width="2.5"/>
  <rect x="48" y="70" width="24" height="44" rx="11" fill="${GREY}" stroke="${NAVY}" stroke-width="2.5"/>
  <path d="M40 50 q20 -10 40 0 v14 q-20 12 -40 0 z" fill="${BLUE}" stroke="${NAVY}" stroke-width="2.5"/>
  <ellipse cx="60" cy="68" rx="22" ry="9" fill="${TAN_L}" stroke="${NAVY}" stroke-width="2.5"/>`);
const illuSkin = svgWrap(`
  <rect x="10" y="78" width="100" height="34" fill="${TAN}" stroke="${NAVY}" stroke-width="2"/>
  <rect x="10" y="68" width="100" height="12" fill="${TAN_L}" stroke="${NAVY}" stroke-width="2"/>
  ${[26,46,66,86].map(x=>`<path d="M${x} 70 q3 -40 0 -64" stroke="${NAVY}" stroke-width="3.5" fill="none" stroke-linecap="round"/><circle cx="${x}" cy="92" r="5" fill="${BLUE}"/>`).join('')}`);
const illuGut = svgWrap(`
  <rect x="14" y="14" width="92" height="92" rx="8" fill="${TAN_L}" stroke="${NAVY}" stroke-width="2.5"/>
  ${[24,44,64,84].map(x=>`<path d="M${x} 16 q-7 18 0 36 q7 18 0 36" stroke="${NAVY}" stroke-width="2.5" fill="none"/>`).join('')}
  ${[34,54,74].map((x,i)=>`<rect x="${x}" y="${40+i*8}" width="14" height="6" rx="3" fill="${BLUE}" transform="rotate(${20-i*15} ${x+7} ${43+i*8})"/>`).join('')}`);
const illuEnergy = svgWrap(`
  <ellipse cx="60" cy="60" rx="34" ry="46" fill="${TAN}" stroke="${NAVY}" stroke-width="2.5"/>
  <path d="M44 36 q16 12 32 0 M44 60 q16 12 32 0 M44 84 q16 12 32 0" stroke="${NAVY}" stroke-width="2.5" fill="none"/>
  ${[[26,40],[94,40],[26,80],[94,80]].map(([x,y])=>`<path d="M${x} ${y} l10 -4 -4 10z" fill="${BLUE}"/>`).join('')}
  <circle cx="60" cy="60" r="8" fill="${BLUE}"/>`);
const illuOrgans = svgWrap(`
  <path d="M60 30 q-14 -18 -26 -4 q-10 12 26 34 q36 -22 26 -34 q-12 -14 -26 4z" fill="${NAVY}"/>
  <path d="M34 70 q-8 22 8 30 q10 6 14 -6 q-10 -14 -22 -24z" fill="${TAN}" stroke="${NAVY}" stroke-width="2"/>
  <path d="M86 70 q8 22 -8 30 q-10 6 -14 -6 q10 -14 22 -24z" fill="${TAN}" stroke="${NAVY}" stroke-width="2"/>`);
const illuImmune = svgWrap(`
  <circle cx="60" cy="60" r="20" fill="${NAVY}"/>
  <circle cx="60" cy="60" r="30" fill="none" stroke="${BLUE}" stroke-width="2.5"/>
  ${[0,60,120,180,240,300].map(a=>{const r=44,x=60+r*Math.cos(a*Math.PI/180),y=60+r*Math.sin(a*Math.PI/180);return `<circle cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="9" fill="${TAN}" stroke="${NAVY}" stroke-width="2"/>`;}).join('')}`);

const benefits = [
  {eyebrow:'Mobility', title:'Joint Support', items:['Glucosamine','Chondroitin','Keeps cats mobile'], img:(window.MEOWS_ASSET_BASE+'il-joint.webp')},
  {eyebrow:'Beauty', title:'Skin & Coat', items:['Pure Omega-3','Vitamin E','Skin & coat health'], img:(window.MEOWS_ASSET_BASE+'il-skin.webp')},
  {eyebrow:'Digestion', title:'Gut Health', items:['1 Billion CFU','Regularity support','Nutrient absorption'], img:(window.MEOWS_ASSET_BASE+'il-gut.webp')},
  {eyebrow:'Vitality', title:'Energy', items:['CoQ10','CA-K.G','N.M.M'], img:(window.MEOWS_ASSET_BASE+'il-energy.webp')},
  {eyebrow:'Organs', title:'Organs', items:['Cranberry','Milk Thistle','Liver & Kidneys'], img:(window.MEOWS_ASSET_BASE+'il-organs.webp')},
  {eyebrow:'Protection', title:'Immunity', items:['Essential Taurine','L-Lysine','Antioxidants'], img:(window.MEOWS_ASSET_BASE+'il-immune.webp')},
];
const bg = document.getElementById('benefitGrid');
if(bg) bg.innerHTML = benefits.map(b=>`
  <div class="benefit">
    <div class="b-text">
      <div class="b-eyebrow">${b.eyebrow}</div>
      <div class="b-h">${b.title}</div>
      <ul>${b.items.map(i=>`<li><span class="cd"><svg viewBox="0 0 24 24"><path d="m5 13 4 4 10-10"/></svg></span>${i}</li>`).join('')}</ul>
    </div>
    <div class="b-illu"><img src="${b.img}" alt="${b.title} illustration" /></div>
  </div>`).join('');

// ---- Bestsellers ----
const products = [
  {name:'M-1 Total Cat Health Formula', tag:'20+ ingredients · Chicken', rate:'4.9 · 2,847', price:'$31.99', was:'$39.99', badge:'Bestseller', badgeClass:'lime'},
  {name:'PurrBiotic Digestive Chews', tag:'Fewer hairballs · Salmon', rate:'4.8 · 6,210', price:'$24.00', was:'$36.00', badge:'New', badgeClass:''},
  {name:'JointJump Mobility Scoop', tag:'For 7+ years · Chicken', rate:'4.9 · 8,920', price:'$29.00', was:'$48.00', badge:'-40%', badgeClass:'lime'},
  {name:'ZenCat Calming Drops', tag:'Travel & vet visits', rate:'4.6 · 3,840', price:'$22.00', was:'$32.00', badge:'Vet pick', badgeClass:''},
];
const pg = document.getElementById('prodGrid');
if(pg) pg.innerHTML = products.map((p,idx)=>`
  <div class="pcard">
    <div class="pc-img g${idx+1}">
      <span class="pc-badge ${p.badgeClass}">${p.badge}</span>
      <img src=(window.MEOWS_ASSET_BASE+"pouch.webp") alt="${p.name}" />
    </div>
    <div class="pc-body">
      <div class="pc-rate"><span class="s">★★★★★</span> ${p.rate}</div>
      <div class="pc-name">${p.name}</div>
      <div class="pc-tag">${p.tag}</div>
      <div class="pc-foot">
        <span class="pc-price"><span class="was">${p.was}</span>${p.price}</span>
        <button class="pc-add">Add +</button>
      </div>
    </div>
  </div>`).join('');

// ---- UGC ----
const ugc = [
  {handle:'@catmom_lily', ph:'ugc-ph-1', text:'honestly was skeptical at first but my 14yr old senior is jumping on the counter again after 3 weeks?? his coat is also way softer #MeowsTransformation'},
  {handle:'@theo.and.biscuits', ph:'ugc-ph-2', text:'vacuuming used to be a full hour. its now maybe 15 min. biscuit’s coat literally glows in the sun lol. one scoop, that’s it.'},
  {handle:'@mr.bingus_official', ph:'ugc-ph-3', text:'bingus refuses everything. eveeerything. but he eats this no problem? i sprinkle it over his wet food and he goes in. 4 weeks in & litterbox is also better'},
];
const ug = document.getElementById('ugcGrid');
if(ug) ug.innerHTML = ugc.map((u,idx)=>`
  <div class="ugc">
    <div class="u-img"><img src="${window.MEOWS_ASSET_BASE}ugc${idx+1}.webp" alt="${u.handle}'s cat" /></div>
    <div class="u-body">
      <div class="u-acts"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 21s-7-4.5-9.5-9A5 5 0 0 1 12 6a5 5 0 0 1 9.5 6c-2.5 4.5-9.5 9-9.5 9z"/></svg><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M21 12a8 8 0 0 1-11.5 7.2L3 21l1.8-6.5A8 8 0 1 1 21 12z"/></svg><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="m22 2-7 20-4-9-9-4z"/></svg></div>
      <div class="u-text"><span class="handle">${u.handle}</span> ${u.text}</div>
    </div>
  </div>`).join('');

// ---- Add to cart ----
const cartCount = document.querySelector('.cart-count');
document.addEventListener('click',(e)=>{
  const add = e.target.closest('.pc-add');
  if(add){
    cartCount.textContent = parseInt(cartCount.textContent)+1;
    const orig = add.textContent; add.textContent = 'Added ✓'; add.style.background = '#1BB57B';
    setTimeout(()=>{ add.textContent = orig; add.style.background=''; },1100);
  }
});

// ---- Progress rings ----
document.querySelectorAll('.ring .circle').forEach(c=>{
  const pct = +c.dataset.pct;
  c.style.background = `conic-gradient(${NAVY} ${pct}%, #DDE3EE ${pct}% 100%)`;
  const inner = document.createElement('div');
  inner.style.cssText = 'position:absolute;inset:13px;border-radius:50%;background:#fff;';
  c.appendChild(inner);
  const span = c.querySelector('span');
  span.style.position='relative'; span.style.zIndex='2';
});
